import type { TTransactionHistory } from "../../shared";
import type { ApiRestTypes } from "@lobby/api-client";

export const TRANSACTION_HISTORY_LIMIT = 30;

const THEMES_WITH_REST_TRANSACTION_HISTORY = [
  "richbet",
  "abet",
  "flexbet",
  "fantasybet365",
  "maxibet",
];
const LOBBY_THEME = (import.meta as ImportMeta & { env?: { VITE_THEME?: string } }).env?.VITE_THEME;

export const USE_REST_TRANSACTION_HISTORY = THEMES_WITH_REST_TRANSACTION_HISTORY.includes(
  LOBBY_THEME ?? "",
);

type RestTransactionItem = ApiRestTypes.DefinitionMap["PlayerTransactions.Item"];

export function mapRestTransactionItem(
  item: RestTransactionItem,
  index: number,
): TTransactionHistory[number] {
  const status = item.status === "waiting" ? "active" : item.status;

  return {
    id: `${item.date}-${item.type}-${index}`,
    amount: Math.round(Number(item.amount) * 100),
    createdAt: new Date(item.date * 1000).toISOString(),
    type: item.type,
    status,
    currency: item.currency,
  };
}
